// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hoex","col":"styles_col__uUTU4"};